export enum SegmentEvents {
  SIGN_IN = 'Sign In',
  SIGN_UP = 'Sign Up',
  ONBOARDING_STARTED = 'Onboarding Started',
  ONBOARDING_STEP_COMPLETED = 'Onboarding Step Completed',
  TEAM_CREATED = 'Team Created',
}

export enum OnboardingPath {
  TEAM_CREATION = 'Team Creation',
  CLAIM_PLAYER = 'Claim Player',
}

export enum SegmentAuthMethods {
  APPLE = 'Apple',
  FACEBOOK = 'Facebook',
  GOOGLE = 'Google',
  PHONE = 'Phone',
}

export const normalizeMethod = (method: string) => {
  switch (method) {
    case 'apple.com':
      return SegmentAuthMethods.APPLE;
    case 'facebook.com':
      return SegmentAuthMethods.FACEBOOK;
    case 'google.com':
      return SegmentAuthMethods.GOOGLE;
    default:
      return SegmentAuthMethods.PHONE;
  }
};
